/**
 * Default Widget Configuration
 * Fallback config when API fails or no specific type config exists
 * This mirrors the original hardcoded MachineDetailInfo layout
 */

export const getDefaultConfig = () => ({
  type_id: "default",
  type_name: "기본 설비",
  sections: [
    {
      id: "basic_info",
      title: "설비 상세 정보",
      icon: "Settings",
      widgets: [
        {
          type: "info_list",
          config: {
            items: [
              { label: "관리 번호", dataKey: "machine_manage_code" },
              { label: "카테고리", dataKey: "machine_category_name" },
              { label: "장비 그룹", dataKey: "machine_group_name" },
              { label: "제조사 / 모델", dataKey: "machine_manufacturer", format: "{machine_manufacturer} / {machine_model_name}" },
              { label: "규격 / 전압", dataKey: "machine_size", format: "{machine_size} / {machine_volt}" },
              { label: "구입 일자", dataKey: "machine_purchase_date" },
              { label: "최종 업데이트", dataKey: "machine_update_date" }
            ]
          }
        }
      ]
    },
    {
      id: "risk_assessment",
      title: "위험성 평가 정보",
      icon: "Warning",
      widgets: [
        {
          type: "metric_grid",
          config: {
            columns: 3,
            subHeader: { title: "위험성 평가 현황", popupType: "riskStatus" },
            items: [
              { label: "상", dataKey: "risk_stats.high", unit: "건", color: "red", showDot: true },
              { label: "중", dataKey: "risk_stats.mid", unit: "건", color: "orange", showDot: true },
              { label: "하", dataKey: "risk_stats.low", unit: "건", color: "emerald", showDot: true }
            ]
          }
        },
        {
          type: "metric_grid",
          config: {
            columns: 3,
            subHeader: { title: "개선대책 현황", popupType: "riskMeasure" },
            items: [
              { label: "미수립", dataKey: "measure_stats.none", unit: "건", color: "slate" },
              { label: "수립", dataKey: "measure_stats.set", unit: "건", color: "indigo" },
              { label: "완료", dataKey: "measure_stats.done", unit: "건", color: "emerald" }
            ]
          }
        }
      ]
    },
    {
      id: "accident_history",
      title: "설비 사고 이력",
      icon: "History",
      widgets: [
        {
          type: "metric_grid",
          config: {
            columns: 2,
            subHeader: { title: "사고 및 아차사고 현황", popupType: "accident" },
            items: [
              { label: "사고건수", dataKey: "accident_history.accident", unit: "건", color: "red" },
              { label: "아차사고건수", dataKey: "accident_history.near_miss", unit: "건", color: "orange" }
            ]
          }
        }
      ]
    },
    {
      id: "safety_inspection",
      title: "안전 점검 지표",
      icon: "FactCheck",
      widgets: [
        {
          type: "info_list",
          config: {
            items: [
              { label: "최종 점검일", dataKey: "last_inspection_date" }
            ]
          }
        },
        {
          type: "metric_grid",
          config: {
            columns: 2,
            items: [
              { label: "점검 준수율", dataKey: "inspection_compliance", unit: "%", color: "indigo" },
              { label: "최종 점검 상태", dataKey: "inspection_status", unit: "", color: "emerald" }
            ]
          }
        },
        {
          type: "document_card",
          config: {
            title: "자율안전확인 증명서",
            subtitle: "PDF",
            icon: "PictureAsPdf",
            iconColor: "indigo",
            actionType: "downloadCert",
            dataKey: "machine_manage_code"
          }
        }
      ]
    },
    {
      id: "maintenance",
      title: "설비 보전",
      icon: "Build",
      widgets: [
        {
          type: "metric_grid",
          config: {
            columns: 2,
            subHeader: { title: "설비 이력", popupType: "maintenance" },
            items: [
              { label: "고장건수", dataKey: "maintenance.broken", unit: "건", color: "red" },
              { label: "예방보전실행율", dataKey: "maintenance.compliance", unit: "%", color: "emerald" }
            ]
          }
        },
        {
          type: "date_info",
          config: {
            label: "다음 보전 예정일",
            dataKey: "next_maintenance_date",
            showDday: true,
            color: "orange"
          }
        },
        {
          type: "progress_bar",
          config: {
            dataKey: "maintenance_progress",
            color: "orange"
          }
        }
      ]
    },
    {
      id: "msds",
      title: "MSDS",
      icon: "Description",
      widgets: [
        {
          type: "info_list",
          config: {
            items: [
              { label: "잉크청소", dataKey: "msds.ink_cleaning" },
              { label: "자동날인", dataKey: "msds.auto_stamp" }
            ]
          }
        },
        {
          type: "document_card",
          config: {
            title: "Material Safety Data Sheet",
            subtitle: "PDF • 2.44 MB • VER 1.2",
            icon: "Description",
            iconColor: "red",
            actionType: "openMsds"
          }
        }
      ]
    }
  ]
});

export default getDefaultConfig;
